import React from 'react';

const TagContainer = () => {
	return <div className='tags'></div>;
};

export default TagContainer;
